import { 
    Box, 
    Heading, 
    Image, 
    Text, 
    Badge, 
    VStack, 
    HStack, 
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    List,
    ListItem,
    ListIcon
} from "@chakra-ui/react"
import { useContext } from "react"
import { ThemeContext } from "../context/ThemeContext"
import { LanguageContext } from "../context/LanguageContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"

const Proyecto = (props) => {
    const { theme } = useContext(ThemeContext)
    const { t } = useContext(LanguageContext)
    const { isOpen, onOpen, onClose } = useDisclosure()

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        console.log('Click detected! hasModal:', props.hasModal, 'isOpen:', isOpen)
        if (props.hasModal) {
            console.log('Opening modal...')
            onOpen()
        } else {
            console.log('Opening external link:', props.url)
            window.open(props.url, "_blank", "noopener,noreferrer")
        }
    }
    
    return (
        <>
            {/* Debug info */}
            {props.hasModal && (
                <Text fontSize="0.7rem" color="red.500" position="absolute" top="5px" left="5px" zIndex="999">
                    Modal Enabled
                </Text>
            )}
            <Box
                background={theme.bg.card}
                borderRadius="1rem"
                padding="1.5rem"
                border={`2px solid ${theme.borderColor}`}
                boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
                transition="all 0.3s ease"
                _hover={{
                    transform: "translateY(-8px)",
                    boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)",
                    borderColor: theme.color
                }}
                width="100%"
                maxWidth="350px"
                height="fit-content"
                cursor={props.hasModal ? "pointer" : "default"}
                onClick={handleClick}
            >
            <VStack spacing="1.5rem" alignItems="stretch">
                <Box>
                    <Image
                        src={props.img}
                        borderRadius="0.8rem"
                        height="200px"
                        width="100%"
                        objectFit="cover"
                        border={`1px solid ${theme.borderColor}`}
                    />
                </Box>
                
                <VStack spacing="1rem" alignItems="flex-start">
                    <Heading 
                        as="h3" 
                        fontSize="1.5rem"
                        color={theme.color}
                        _hover={{ 
                            color: theme.bg.landing === "#fff" ? "#2B6CB0" : "#90CDF4" 
                        }}
                        transition="color 0.3s ease"
                        lineHeight="1.3"
                    >
                        {props.hasModal ? (
                            <span>{props.title}</span>
                        ) : (
                            <a href={props.url} target="_blank" rel="noopener noreferrer">
                                {props.title}
                            </a>
                        )}
                    </Heading>
                    
                    <Text 
                        fontSize="0.95rem"
                        color={theme.color}
                        lineHeight="1.5"
                        opacity="0.85"
                        textAlign="left"
                    >
                        {props.description}
                    </Text>
                    
                    {props.technologies && (
                        <Box width="100%">
                            <Text 
                                fontSize="0.85rem" 
                                fontWeight="bold" 
                                color={theme.color}
                                marginBottom="0.8rem"
                                opacity="0.9"
                            >
                                {t('projects.technologies')}
                            </Text>
                            <HStack spacing="0.5rem" flexWrap="wrap">
                                {props.technologies.map((tech, index) => (
                                    <Badge
                                        key={index}
                                        fontSize="0.7rem"
                                        padding="0.3rem 0.6rem"
                                        borderRadius="0.4rem"
                                        bg={theme.bg.landing === "#fff" ? "#F7FAFC" : "#2D3748"}
                                        color={theme.bg.landing === "#fff" ? "#2B6CB0" : "#E2E8F0"}
                                        border={`1px solid ${theme.borderColor}`}
                                        fontWeight="500"
                                    >
                                        {tech}
                                    </Badge>
                                ))}
                            </HStack>
                        </Box>
                    )}
                </VStack>
            </VStack>
        </Box>

        {/* Modal para proyectos con información detallada */}
        {props.hasModal && (
            <>
                {console.log('Rendering modal, isOpen:', isOpen)}
                <Modal isOpen={isOpen} onClose={onClose} size="xl">
                    <ModalOverlay />
                    <ModalContent bg={theme.bg.card} color={theme.color}>
                        <ModalHeader>{props.title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack spacing="1.5rem" alignItems="flex-start">
                            <Image
                                src={props.img}
                                borderRadius="0.8rem"
                                width="100%"
                                height="250px"
                                objectFit="cover"
                                border={`1px solid ${theme.borderColor}`}
                            />
                            
                            <Text fontSize="1rem" lineHeight="1.6">
                                {props.fullDescription?.overview}
                            </Text>

                            {props.fullDescription?.functionality && (
                                <Box width="100%">
                                    <Heading as="h4" size="md" marginBottom="1rem">
                                        {t('projects.functionality')}
                                    </Heading>
                                    <List spacing="0.5rem">
                                        {props.fullDescription.functionality.map((item, index) => (
                                            <ListItem key={index} display="flex" alignItems="flex-start">
                                                <ListIcon as={() => <FontAwesomeIcon icon={faCheckCircle} color="#10B981" />} marginTop="0.2rem" marginRight="0.5rem" />
                                                <Text>{item}</Text>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            )}

                            {props.fullDescription?.applications && (
                                <Box width="100%">
                                    <Heading as="h4" size="md" marginBottom="1rem">
                                        {t('projects.applications')}
                                    </Heading>
                                    <List spacing="0.5rem">
                                        {props.fullDescription.applications.map((item, index) => (
                                            <ListItem key={index} display="flex" alignItems="flex-start">
                                                <ListIcon as={() => <FontAwesomeIcon icon={faCheckCircle} color="#3182CE" />} marginTop="0.2rem" marginRight="0.5rem" />
                                                <Text>{item}</Text>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            )}

                            {props.technologies && (
                                <Box width="100%">
                                    <Heading as="h4" size="md" marginBottom="1rem">
                                        {t('projects.technologies')}
                                    </Heading>
                                    <HStack spacing="0.5rem" flexWrap="wrap">
                                        {props.technologies.map((tech, index) => (
                                            <Badge
                                                key={index}
                                                fontSize="0.8rem"
                                                padding="0.4rem 0.8rem"
                                                borderRadius="0.5rem"
                                                bg={theme.bg.landing === "#fff" ? "#F7FAFC" : "#2D3748"}
                                                color={theme.bg.landing === "#fff" ? "#2B6CB0" : "#E2E8F0"}
                                                border={`1px solid ${theme.borderColor}`}
                                                fontWeight="500"
                                            >
                                                {tech}
                                            </Badge>
                                        ))}
                                    </HStack>
                                </Box>
                            )}
                        </VStack>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            as="a"
                            href={props.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            bg={theme.bg.landing === "#fff" ? "#2B6CB0" : "#4299E1"}
                            color="white"
                            _hover={{
                                bg: theme.bg.landing === "#fff" ? "#2C5282" : "#3182CE"
                            }}
                            leftIcon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
                            marginRight="1rem"
                        >
                            {t('projects.viewProject')}
                        </Button>
                        <Button variant="ghost" onClick={onClose}>
                            {t('projects.close')}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            </>
        )}
    </>
    )
}

export default Proyecto